import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { data, useNavigate } from 'react-router-dom'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import ManagerHeader from './ManagerHeader'
import { sidebarContext } from '../../App'
import { FaArrowRight, FaPlus, FaUniversity } from 'react-icons/fa'

export default function AllocateBeds() {
  const navigate = useNavigate()
  const {setHS} = useContext(sidebarContext)

  useEffect(() => {
    setHS(2)
  },[setHS])

  const AllocateBedCard = ({icon, title, description, color, onClick}) => {
    return(
      <div
        onClick={onClick}
        className='group relative overflow-hidden cursor-pointer bg-white rounded-3xl border border-slate-200 p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:translate-y-1'
      >
        {/* Top Section */}
        <div className='flex items-start justify-between'>
          <div className={`w-16 h-16 rounded-xl flex items-center justify-center ${color} shadow-md`}>
            {icon}
          </div>

          <div className='opacity-0 group-hover:opacity-100 transition duration-300'>
            <FaArrowRight className='text-slate-400 text-lg'/>
          </div>
        </div>

        {/* Content */}
        <div className='mt-6'>
          <h2 className='text-2xl font-bold'>{title}</h2>
          <p className='text-slate-500 mt-2 leading-relaxed'>{description}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 via-blue-50 to-slate-200 ml-64 5xl:ml-0 justify-between items-center">
      <ManagerHeader />
      
      <div className="max-w-7xl mx-auto mt-16 px-6 py-6">

        {/* Header */}
        <div className="mb-8 text-center font-serif">
          <h1 className="text-3xl font-bold text-slate-800 uppercase">
            Manage Departments
          </h1>

          <p className="text-xl text-slate-600 mt-2">
            Create, organize and manage all departments from a centralized location
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-2 4xl:grid-cols-1 gap-8">
          <AllocateBedCard
            title="Add Allocate Bed"
            description="Create and allocate a new bed with address and landmark details."
            icon={<FaPlus className="text-green-600 text-2xl" />}
            color="bg-green-100"
            onClick={() => navigate('/manager/add_allocate_bed')}
          />

          <AllocateBedCard
            title="All Allocated Beds"
            description="View, edit, and manage all allocate bed from one place."
            icon={<FaUniversity className="text-blue-600 text-2xl" />}
            color="bg-blue-100"
            onClick={() => navigate('/manager/all_allocate_bed')}
          />
        </div>
      </div>
    </div>
  )
}
